// extracted by mini-css-extract-plugin
module.exports = {"box":"box-3UPIdfRV","ad_box":"ad_box-vdTDYOJl clearfix","fl":"fl-1d1x8OnM fl","fr":"fr-3jFLz_pk fr","ad":"ad-7XY48bIk"};